<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 15 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g transform="matrix(1.14677,0,0,1.14677,-0.539793,2.88809)">
      <path
        d="M5.5,1L4,1C2.343,1 1,2.343 1,4C1,5.657 2.343,7 4,7L5.5,7M8.5,1L10,1C11.657,1 13,2.343 13,4C13,5.657 11.657,7 10,7L8.5,7M4.5,4L9.5,4"
        style="fill:none;fill-rule:nonzero;stroke:currentColor;stroke-width:1px;"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LinkIcon'
}
</script>
